import { library as a } from "@fortawesome/fontawesome-svg-core";
import { faArrowUpRightFromSquare as f, faCalendarAlt as r, faCheck as e, faCircleCheck as i, faClipboardList as l, faClock as o, faComment as n, faExclamationCircle as t, faFilePdf as s, faFileImage as m, faFileWord as c, faFileExcel as d, faFileAlt as C, faHandHoldingHeart as g, faHome as F, faMagnifyingGlass as p, faTrash as h, faRotate as A, faSignOutAlt as H, faSpinner as S, faUser as U, faUserSlash as k, faUserFriends as x, faWarning as b } from "@fortawesome/free-solid-svg-icons";
const u = [
  f,
  r,
  e,
  i,
  l,
  o,
  n,
  t,
  s,
  m,
  c,
  d,
  C,
  g,
  F,
  p,
  h,
  A,
  H,
  S,
  U,
  k,
  x,
  b
];
a.add(...u);
export {
  u as i
};
